import React from 'react'

export default function Divisas2() {
  return (
    <div>Divisas2</div>
  )
}
